"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "scan-manage_layout" };
var _hoisted_2 = { class: "form-container" };
var _hoisted_3 = { class: "form-title" };
var _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h4", null, "书籍管理", -1);
var _hoisted_5 = { class: "button-box" };
var _hoisted_6 = { class: "table-box" };
var _hoisted_7 = { class: "dialog-footer" };
var vue_3 = require("vue");
var element_plus_1 = require("element-plus");
var book_store_1 = require("@/apis/book-store");
var TableUnit_vue_1 = __importDefault(require("@/components/Table/TableUnit.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'IndexView',
    setup: function (__props) {
        /* eslint-disable */
        var columns = (0, vue_3.reactive)([
            // {
            //   title: 'ID',
            //   dataIndex: 'id',
            //   width: 80,
            //   align: "center",
            // },
            {
                title: '书籍名称',
                dataIndex: 'name',
                align: "center",
            },
            {
                title: '书籍作者',
                dataIndex: 'author',
                align: "center",
            },
            {
                title: '作者国家',
                dataIndex: 'country',
                align: "center",
            },
            {
                title: '文学体裁',
                dataIndex: 'genre',
                align: "center",
            },
            {
                title: '添加时间',
                dataIndex: 'add_date',
                width: 160,
                align: "center",
            },
            {
                title: '创作时间(年)',
                dataIndex: 'years',
                align: "center",
            },
            {
                title: '出版社',
                dataIndex: 'publisher',
                align: "center",
            },
            {
                title: '价格(元)',
                dataIndex: 'price',
                align: "center",
                width: 100,
            },
            {
                title: '豆瓣评分',
                dataIndex: 'douban_score',
                align: "center",
                width: 100,
            },
            {
                title: '书籍简介',
                dataIndex: 'description',
                align: "center",
                overflow: true,
            },
            {
                title: '操作',
                dataIndex: 'operate',
                align: "center",
                width: 120,
            },
        ]);
        var pickerOptions = (0, vue_3.ref)({
            shortcuts: [
                {
                    text: '最近一周',
                    value: function () {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        return [start, end];
                    },
                },
                {
                    text: '最近一个月',
                    value: function () {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        return [start, end];
                    },
                },
                {
                    text: '最近三个月',
                    value: function () {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        return [start, end];
                    },
                },
            ],
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            },
        });
        var list = (0, vue_3.ref)([]);
        var total = (0, vue_3.ref)(0);
        var params = (0, vue_3.ref)({
            page: 1,
            limit: 10,
            publisher: '',
            name: '',
            startTime: '',
            endTime: '',
            author: "",
            years: "",
            genre: "",
            country: "",
        });
        var searchDate = (0, vue_3.ref)([params.value.startTime, params.value.endTime]);
        var editDialogVisible = (0, vue_3.ref)(false);
        var isShowMoreSearch = (0, vue_3.ref)(false);
        var dataEditForm = (0, vue_3.ref)({
            name: '',
            publisher: '',
            years: '',
            author: '',
            id: null,
            description: "",
            price: "",
            genre: "",
            country: "",
        });
        var fetchTableData = function () {
            book_store_1.booksApi.getBooksList(params.value).then(function (res) {
                list.value = res.data.result;
                total.value = res.data.total;
            });
        };
        fetchTableData();
        var handleSizeChange = function (val) {
            params.value.limit = val;
            params.value.page = 1;
            fetchTableData();
        };
        var handleCurrentChange = function (val) {
            params.value.page = val;
            fetchTableData();
        };
        var handleSearch = function () {
            params.value.page = 1;
            if (searchDate.value && searchDate.value.length > 0) {
                params.value.startTime = searchDate.value[0];
                params.value.endTime = searchDate.value[1];
            }
            else {
                params.value.startTime = '';
                params.value.endTime = '';
            }
            fetchTableData();
        };
        var reSearch = function () {
            params.value = {
                page: 1,
                limit: 10,
                publisher: '',
                name: '',
                startTime: '',
                endTime: '',
                years: "",
                author: "",
                genre: "",
                country: "",
            };
            searchDate.value = [];
            fetchTableData();
        };
        var editRow = function (value) {
            book_store_1.booksApi.getBookInfo(value.id).then(function (res) {
                dataEditForm.value = res.data;
                editDialogVisible.value = true;
            });
        };
        var addTask = function () {
            editDialogVisible.value = true;
            dataEditForm.value = {
                name: '',
                publisher: '',
                years: '',
                author: "",
                id: null,
                description: "",
                price: "",
                genre: "",
                country: "",
            };
        };
        var confirmEdit = function () {
            (0, element_plus_1.ElMessage)({
                type: 'warning',
                message: '该数据禁止操作',
            });
            return;
            if (!dataEditForm.value.name) {
                element_plus_1.ElMessage.warning("书籍名不能为空");
                return;
            }
            if (dataEditForm.value.id) {
                book_store_1.booksApi.putBookInfo(dataEditForm.value, dataEditForm.value.id).then(function (res) {
                    if (res.code == 200) {
                        element_plus_1.ElMessage.success("修改成功");
                        editDialogVisible.value = false;
                        fetchTableData();
                    }
                });
            }
            else {
                book_store_1.booksApi.addBook(dataEditForm.value).then(function (res) {
                    if (res.code == 200) {
                        element_plus_1.ElMessage.success("新增成功");
                        editDialogVisible.value = false;
                        fetchTableData();
                    }
                });
            }
        };
        var delRow = function (value) {
            (0, element_plus_1.ElMessage)({
                type: 'warning',
                message: '该数据禁止操作',
            });
            return;
            element_plus_1.ElMessageBox.confirm('此操作将删除该条书籍信息，是否继续?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(function () {
                book_store_1.booksApi.deleteBookInfo(value.id).then(function (res) {
                    if (res.code == 200) {
                        (0, element_plus_1.ElMessage)({
                            type: 'success',
                            message: '删除成功',
                        });
                        fetchTableData();
                    }
                });
            });
        };
        return function (_ctx, _cache) {
            var _component_el_button = (0, vue_2.resolveComponent)("el-button");
            var _component_el_input = (0, vue_2.resolveComponent)("el-input");
            var _component_el_form_item = (0, vue_2.resolveComponent)("el-form-item");
            var _component_el_date_picker = (0, vue_2.resolveComponent)("el-date-picker");
            var _component_el_form = (0, vue_2.resolveComponent)("el-form");
            var _component_el_dialog = (0, vue_2.resolveComponent)("el-dialog");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        _hoisted_4,
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createVNode)(_component_el_button, {
                                type: "primary",
                                onClick: handleSearch,
                                icon: "Search"
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createTextVNode)("查询")
                                ]; }),
                                _: 1
                            }),
                            (0, vue_2.createVNode)(_component_el_button, {
                                type: "primary",
                                onClick: reSearch,
                                plain: "",
                                icon: "RefreshLeft"
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createTextVNode)("重置")
                                ]; }),
                                _: 1
                            }),
                            (0, vue_2.createVNode)(_component_el_button, {
                                onClick: addTask,
                                plain: "",
                                icon: "Plus",
                                disabled: ""
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createTextVNode)("新增")
                                ]; }),
                                _: 1
                            }),
                            (0, vue_2.createVNode)(_component_el_button, {
                                onClick: _cache[0] || (_cache[0] = function ($event) { return ((0, vue_2.isRef)(isShowMoreSearch) //@ts-ignore
                                    ? isShowMoreSearch.value = !(0, vue_2.unref)(isShowMoreSearch) : isShowMoreSearch = !(0, vue_2.unref)(isShowMoreSearch)); }),
                                plain: "",
                                icon: (0, vue_2.unref)(isShowMoreSearch) ? 'ArrowUp' : 'ArrowDown'
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(isShowMoreSearch) ? '收起' : '展开'), 1)
                                ]; }),
                                _: 1
                            }, 8, ["icon"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", {
                        class: "form-params",
                        style: (0, vue_2.normalizeStyle)((0, vue_2.unref)(isShowMoreSearch) ? 'height:100px' : 'height:45px')
                    }, [
                        (0, vue_2.createVNode)(_component_el_form, {
                            inline: true,
                            class: "demo-form-inline",
                            "label-width": "90px",
                            model: (0, vue_2.unref)(params)
                        }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "书籍名称:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            clearable: "",
                                            onKeydown: (0, vue_2.withKeys)(handleSearch, ["enter"]),
                                            modelValue: (0, vue_2.unref)(params).name,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return (((0, vue_2.unref)(params).name) = $event); })
                                        }, null, 8, ["onKeydown", "modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "书籍作者:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            clearable: "",
                                            onKeydown: (0, vue_2.withKeys)(handleSearch, ["enter"]),
                                            modelValue: (0, vue_2.unref)(params).author,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return (((0, vue_2.unref)(params).author) = $event); })
                                        }, null, 8, ["onKeydown", "modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "出版社:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            clearable: "",
                                            onKeydown: (0, vue_2.withKeys)(handleSearch, ["enter"]),
                                            modelValue: (0, vue_2.unref)(params).publisher,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return (((0, vue_2.unref)(params).publisher) = $event); })
                                        }, null, 8, ["onKeydown", "modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "作者国家:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            clearable: "",
                                            onKeydown: (0, vue_2.withKeys)(handleSearch, ["enter"]),
                                            modelValue: (0, vue_2.unref)(params).country,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return (((0, vue_2.unref)(params).country) = $event); })
                                        }, null, 8, ["onKeydown", "modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "文学体裁:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            clearable: "",
                                            onKeydown: (0, vue_2.withKeys)(handleSearch, ["enter"]),
                                            modelValue: (0, vue_2.unref)(params).genre,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return (((0, vue_2.unref)(params).genre) = $event); })
                                        }, null, 8, ["onKeydown", "modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "创作时间:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            clearable: "",
                                            onKeydown: (0, vue_2.withKeys)(handleSearch, ["enter"]),
                                            modelValue: (0, vue_2.unref)(params).years,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return (((0, vue_2.unref)(params).years) = $event); })
                                        }, null, 8, ["onKeydown", "modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "添加时间:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_date_picker, {
                                            clearable: "",
                                            modelValue: (0, vue_2.unref)(searchDate),
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((0, vue_2.isRef)(searchDate) ? (searchDate).value = $event : searchDate = $event); }),
                                            shortcuts: pickerOptions.value.shortcuts,
                                            "disabled-date": pickerOptions.value.disabledDate,
                                            type: "datetimerange",
                                            "range-separator": "至",
                                            "value-format": "YYYY-MM-DD hh:mm:ss",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                        }, null, 8, ["modelValue", "shortcuts", "disabled-date"])
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        }, 8, ["model"])
                    ], 4)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_6, [
                    (0, vue_2.createVNode)(TableUnit_vue_1.default, {
                        list: (0, vue_2.unref)(list),
                        columns: columns,
                        onHandleCurrentChange: handleCurrentChange,
                        onHandleSizeChange: handleSizeChange,
                        total: (0, vue_2.unref)(total),
                        currentPage: (0, vue_2.unref)(params).page
                    }, {
                        default: (0, vue_2.withCtx)(function (record) { return [
                            (0, vue_2.createVNode)(_component_el_button, {
                                plain: "",
                                size: "small",
                                disabled: "",
                                icon: "Edit",
                                type: "primary",
                                onClick: function ($event) { return (editRow(record.record)); }
                            }, null, 8, ["onClick"]),
                            (0, vue_2.createVNode)(_component_el_button, {
                                plain: "",
                                size: "small",
                                disabled: "",
                                icon: "Delete",
                                type: "danger",
                                onClick: function ($event) { return (delRow(record.record)); }
                            }, null, 8, ["onClick"])
                        ]; }),
                        _: 1
                    }, 8, ["list", "columns", "total", "currentPage"])
                ]),
                (0, vue_2.createVNode)(_component_el_dialog, {
                    title: "书籍编辑",
                    top: "6vh",
                    modelValue: (0, vue_2.unref)(editDialogVisible),
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) { return ((0, vue_2.isRef)(editDialogVisible) ? (editDialogVisible).value = $event : editDialogVisible = $event); }),
                    width: "50%"
                }, {
                    footer: (0, vue_2.withCtx)(function () { return [
                        (0, vue_2.createElementVNode)("span", _hoisted_7, [
                            (0, vue_2.createVNode)(_component_el_button, {
                                onClick: _cache[16] || (_cache[16] = function ($event) { return ((0, vue_2.isRef)(editDialogVisible) //@ts-ignore
                                    ? editDialogVisible.value = false : editDialogVisible = false); })
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createTextVNode)("取 消")
                                ]; }),
                                _: 1
                            }),
                            (0, vue_2.createVNode)(_component_el_button, {
                                type: "primary",
                                onClick: confirmEdit
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createTextVNode)("确 定")
                                ]; }),
                                _: 1
                            })
                        ])
                    ]; }),
                    default: (0, vue_2.withCtx)(function () { return [
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createVNode)(_component_el_form, {
                                "label-width": "120px",
                                model: (0, vue_2.unref)(dataEditForm)
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        label: "书籍名称",
                                        required: ""
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                modelValue: (0, vue_2.unref)(dataEditForm).name,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return (((0, vue_2.unref)(dataEditForm).name) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, { label: "书籍作者" }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                modelValue: (0, vue_2.unref)(dataEditForm).author,
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return (((0, vue_2.unref)(dataEditForm).author) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, { label: "出版社" }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                modelValue: (0, vue_2.unref)(dataEditForm).publisher,
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) { return (((0, vue_2.unref)(dataEditForm).publisher) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, { label: "作者国家" }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                modelValue: (0, vue_2.unref)(dataEditForm).country,
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) { return (((0, vue_2.unref)(dataEditForm).country) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, { label: "文学体裁" }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                modelValue: (0, vue_2.unref)(dataEditForm).genre,
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) { return (((0, vue_2.unref)(dataEditForm).genre) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, { label: "出版时间" }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                modelValue: (0, vue_2.unref)(dataEditForm).years,
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) { return (((0, vue_2.unref)(dataEditForm).years) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, { label: "书籍定价" }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                modelValue: (0, vue_2.unref)(dataEditForm).price,
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) { return (((0, vue_2.unref)(dataEditForm).price) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, { label: "书籍简介" }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                rows: 5,
                                                type: "textarea",
                                                modelValue: (0, vue_2.unref)(dataEditForm).description,
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) { return (((0, vue_2.unref)(dataEditForm).description) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    })
                                ]; }),
                                _: 1
                            }, 8, ["model"])
                        ])
                    ]; }),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
